import apiClient from './client';
import type { ApiResponse, ListParams, PaginationMeta } from '../types';

export interface VendorNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  priority: 'low' | 'medium' | 'high' | 'urgent';
  is_read: boolean;
  read_at: string | null;
  created_at: string;
}

export const notificationsApi = {
  async list(
    params?: ListParams & { unread?: boolean }
  ): Promise<{ items: VendorNotification[]; meta: PaginationMeta }> {
    const res = await apiClient.get<ApiResponse<VendorNotification[]>>(
      '/vendor/notifications',
      { params }
    );
    return { items: res.data.data, meta: res.data.meta! };
  },

  async unreadCount(): Promise<number> {
    const res = await apiClient.get<ApiResponse<{ unread: number }>>(
      '/vendor/notifications/unread-count'
    );
    return res.data.data.unread;
  },

  async markRead(id: string): Promise<VendorNotification> {
    const res = await apiClient.patch<ApiResponse<VendorNotification>>(
      `/vendor/notifications/${id}/read`
    );
    return res.data.data;
  },

  async markAllRead(): Promise<number> {
    const res = await apiClient.post<ApiResponse<{ marked_read: number }>>(
      '/vendor/notifications/read-all'
    );
    return res.data.data.marked_read;
  },
};
